import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class BancoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerBancoEmpresas(empresa_rut, activado, callback: Function) {
    const inputParams = {
      entidad: {
        empresa_rut,
        activado,
      }
    }

    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: bancoInputType) {
          banco {
            obtenerBancoEmpresas(entidad: $entidad) {
              respuesta {
                registros {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.banco.obtenerBancoEmpresas
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSegunFiltro(nombre, activado, callback: Function) {
    const inputParams = {
      entidad:{
        nombre,
        activado
      }
    }

    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: bancoInputType) {
          banco {
            obtenerSegunFiltro(filtro: {exacto: $entidad}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.banco.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

}
